<template>
    <!-- @TODO: shared/ui/TableList  -->
    <table class="control-table users-table">
        <thead class="control-table__head">
            <tr class="control-table__row">
                <th
                    v-if="selectable"
                    style="width: 5%; max-width: 100px"
                    class="control-table__cell users-table__cell"
                >
                    <Checkbox v-model="checkedAll" @update:model-value="selectAll" />
                </th>
                <slot name="head-row-prepend"></slot>
                <slot name="head-rows">
                    <th
                        style="width: 5%; max-width: 100px"
                        class="control-table__cell users-table__cell"
                    >
                        <div class="control-table__cell-inner">
                            {{ $t('crm.users.list.id') }}
                            <TableSorting
                                v-if="sortingFields.includes('id')"
                                v-model="ordering"
                                field="id"
                            />
                        </div>
                    </th>
                    <th
                        style="width: 20%; min-width: 200px; max-width: 250px"
                        class="control-table__cell users-table__cell"
                    >
                        <div class="control-table__cell-inner">
                            {{ $t('crm.users.list.email') }}
                            <TableSorting
                                v-if="sortingFields.includes('email')"
                                v-model="ordering"
                                field="email"
                            />
                        </div>
                    </th>
                    <th
                        style="width: 20%; min-width: 200px; max-width: 250px"
                        class="control-table__cell users-table__cell"
                    >
                        <div class="control-table__cell-inner">
                            {{ $t('crm.users.list.name') }}
                        </div>
                    </th>
                    <th
                        style="width: 20%; min-width: 200px; max-width: 250px"
                        class="control-table__cell users-table__cell"
                    >
                        <div class="control-table__cell-inner">
                            {{ $t('crm.users.list.role') }}
                        </div>
                    </th>
                </slot>
                <slot name="head-row-append" :ordering="ordering"></slot>
            </tr>
        </thead>
        <tbody class="control-table__body">
            <template v-if="users.length">
                <tr
                    v-for="user in users"
                    :key="user.id"
                    :class="[
                        'control-table__row',
                        'users-table__row',
                        {
                            'users-table__row--selected': 0,
                        },
                    ]"
                >
                    <td v-if="selectable" class="control-table__cell users-table__cell">
                        <Checkbox v-model="selectedUsers" :value="user.id" />
                    </td>
                    <slot name="item-row-prepend" :user="user"></slot>
                    <slot name="item-rows" :user="user">
                        <td class="control-table__cell users-table__cell">
                            {{ user.user.id }}
                        </td>
                        <td class="control-table__cell users-table__cell">
                            <div class="users-table__cell-nowrap">
                                <div v-if="user.user.photo" class="users-table__userpic">
                                    <img :src="user.user.photo" />
                                </div>

                                <router-link
                                    v-if="userRouter"
                                    :to="{
                                        name: userRouter,
                                        params: { id: user.id },
                                    }"
                                >
                                    <b>{{ user.user.email }}</b>
                                </router-link>
                                <b v-else>{{ user.user.email }}</b>
                            </div>
                        </td>
                        <td class="control-table__cellusers-table__cell">
                            {{ user.user.full_name }}
                        </td>
                        <td class="control-table__cell users-table__cell">
                            <ul class="users-table__roles">
                                <li
                                    v-for="role in user.role"
                                    :key="role.slug"
                                    v-text="role.label"
                                ></li>
                            </ul>
                        </td>
                    </slot>
                    <slot name="item-row-append" :user="user"></slot>
                    <td class="control-table__cell users-table__cell">
                        <div class="users-table__actions">
                            <slot name="item-actions" :user="user"></slot>
                        </div>
                    </td>
                </tr>
            </template>
        </tbody>
    </table>
</template>

<script>
import { Checkbox } from '@speechki-frontend/shared/ui/forms';
import TableSorting from '@speechki-frontend/shared/ui/TableSorting';
import { mapGetters } from 'vuex';

export default {
    name: 'UsersTable',
    components: {
        Checkbox,
        TableSorting,
    },
    props: {
        users: {
            type: Array,
            default: () => [],
        },
        sortingFields: {
            type: Array,
            default: () => [],
        },
        selectable: {
            type: Boolean,
            default: false,
        },
        customizable: {
            type: Boolean,
            default: false,
        },
        userRouter: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            checkedAll: false,
            ordering: '-id',
        };
    },
    computed: {
        ...mapGetters(['isAdmin']),

        selectedUsers: {
            get() {
                const { selectedUsers } = this.$store.state.users;
                return selectedUsers;
            },
            set(value) {
                this.$store.commit('users/SET_SELECTED_USERS', value);
            },
        },
    },
    watch: {
        ordering() {
            this.$emit('sort', this.ordering);
        },
        'selectedUsers.length'(value) {
            this.checkedAll = !!value;
        },
    },
    methods: {
        selectAll(option) {
            const users = option ? this.users.map((user) => user.id) : [];
            this.selectedUsers = users;
        },
    },
};
</script>

<style src="./UsersTable.scss" lang="scss"></style>
